import React, { useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Dropdown from "components/atoms/Dropdown/Dropdown";
import AnalyticsContext from "./analyticsContext";

function GraphDateFilter() {
  const intl = useIntl();
  const { params, setAnalyticsFilterBy } = useContext(AnalyticsContext);

  const options = [
    {
      label: intl.formatMessage({
        id: "report.week",
        defaultMessage: "Week",
      }),
      value: "week",
    },
    {
      label: intl.formatMessage({
        id: "report.month",
        defaultMessage: "Month",
      }),
      value: "month",
    },
    {
      label: intl.formatMessage({
        id: "report.year",
        defaultMessage: "Year",
      }),
      value: "year",
    },
  ];

  return (
    <div className="d-flex flex-column ml-sm-2 mb-xs-2">
      <span>
        <FormattedMessage id="report.period" defaultMessage="Period" />
      </span>
      <Dropdown
        options={options}
        onChange={(item) => setAnalyticsFilterBy(item.value)}
        defaultValue={options.filter((item) => item.value === params.analytics_filter_by)[0].label}
      />
    </div>
  );
}

export default GraphDateFilter;
